import { FleekError } from './FleekError';

type SitesNotFoundErrorOptions = Record<string, never>;

export class SitesNotFoundError extends FleekError<SitesNotFoundErrorOptions> {
  public name = 'SitesNotFoundError';

  constructor() {
    super({});
  }

  toString = () => 'No sites found.';
}
